/******************************************************
 *                  Open-iti import
 ********************************************************/

"use strict";

angular.module("exploitation")

	.controller("OpenImportsCtrlParent", ["$scope", "OpenImportsService", "Utils", "$uibModal", "toastr", "$location",
		function ($scope, OpenImportsService, Utils, $uibModal, toastr, $location) {

		var deleteModal;
		$scope.data = {};

		/**
		 * Récupérer une classe bootstrap pour l'affichage des cartes correspondant
		 * aux imports en fonction du statut de l'import.
		 * @param status
		 * @returns {string}
		 */
		$scope.getStatusClass = function (status, result_job) {
			var statusClass = "";

			switch (result_job){
				case 'NOK' :
					statusClass = "danger";
					break;
				default :
					switch (status) {
						case "TERMINATED" :
							statusClass = "success";
							break;
						case "ABORTED" :
							statusClass = "danger";
							break;
						case "FAILED" :
							statusClass = "danger";
							break;
						case "STARTED" :
							statusClass = "info";
							break;
						default:
							statusClass = "default";
					}
			}
			return statusClass;
		};


		/**
		 * Ouvrir la modal de suppression d'un import.
		 */
		$scope.openDeleteModal = function (importInfo) {
			$scope.data.importToDelete = importInfo;
			deleteModal = Utils.openModal($uibModal, "delete.html", $scope);
		};

		/**
		 * retourne le nombre de coordonnées manquantes
		 * @returns {*}
		 */
		$scope.getNbMissingCoordinates = function() {

			var errors = $scope.data.actionReport.files
												.filter(e => e.name === "stops.txt" && e.status === "ERROR")
												.flatMap((e)=>{ return e.errors;})


			if (errors.filter( e => e !== undefined).length == 0){
				return 0;
			}

			return $scope.data.actionReport.files
				.filter(e => e.name === "stops.txt" && e.status === "ERROR")
				.flatMap((e)=>{ return e.errors;})
				.filter(e => e.description.indexOf("1-GTFS-Common-12" && (e.description.indexOf("stop_lat") || e.description.indexOf("stop_lat")))).length / 2;
		}

		/**
		 * calcule le nb de colonne manquante end_date et start_date
		 * @returns {*}
		 */
		$scope.getNbMissingCalendarDate = function() {
			return $scope.data.actionReport.files
				.filter(e => e.name === "calendar.txt" && e.status === "ERROR")
				.flatMap((e)=>{ return e.errors;})
				.filter(e => e.description.indexOf("1-GTFS-Common-12" && (e.description.indexOf("start_date") || e.description.indexOf("end_date")))).length;
		}

		/**
		 * Supprimer un import, notifications, et fermer la modale en cas de succès.
		 * @param import L'import à supprimer.
		 */
		$scope.deleteImport = function (importInfo) {
			OpenImportsService.deleteImport(importInfo).then(() => {
				toastr.success("L'import " + importInfo.action_parameters.name + " a bien été supprimé.", "Import supprimé");
				deleteModal.close();
				if ($scope.data.detailMode) {
					$location.path("e-iti/imports");
				} else {
					OpenImportsService.getAllImports().then((response) => {
						$scope.data.imports = response.data;
					});
				}
			}).catch(function (data) {
				var errorMessage = "Problème lors de la suppression de l'import. ";
				if (data !== undefined && data.message) {
					errorMessage += data.message;
				}
				toastr.error(errorMessage, "Erreur");
			});
		};

		$scope.downloadDataFile = function (importData) {

			// Récupérer le nom du fichier de données.
			var dataFileName;
			for (var linkIndex in importData.links) {
				var link = importData.links[linkIndex];
				if (link.rel === "data") {
					dataFileName = link.href.substr(link.href.lastIndexOf("/") + 1);
					break;
				}
			}

			if (dataFileName !== undefined) {
				OpenImportsService.getImportDataFile(importData.referential, importData.id, dataFileName)
					.then((response) => {
						var blob = new Blob([response.data], {type: "octet/stream"});
						var a = document.createElement("a");
						var url = (window.URL || window.webkitURL).createObjectURL(blob);
						a.href = url;
						a.target = "_blank";
						a.download = dataFileName;
						document.body.appendChild(a);
						a.click();
					});
			} else {
				toastr.error("Le fichier est introuvable sur le serveur.", "Problème lors du téléchargement");
			}
		};

		$scope.downloadValidationReportFile = function (importData) {
			OpenImportsService.getValidationReport(importData.referential, importData.id)
				.then((response) => {
					let a = document.createElement("a");
					// Utilisation de encodeURIComponent pour s'assurer que les données sont correctement encodées
					let fileContent = encodeURIComponent(JSON.stringify(response.data));
					a.href = "data:text/json;charset=utf-8," + fileContent;
					a.target = "_blank";
					a.download = importData.action_parameters.name + ".json";
					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a); // Nettoyer en supprimant l'élément après le téléchargement
				});
		};


	}]);
